/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */

// Angular
import { NgModule } from '@angular/core';

// NGC File Controls

/**
 * NGC File Module
 */

export class NgcFileModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    exports: [
    ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
